import { useDataChange, useDataValue } from 'Simple/Data.js'
import React, { useEffect } from 'react'
import View from './view.js'

export default function Logic(props) {
  let locations = useDataValue({
    context: 'locations',
    viewPath: props.viewPath,
  })
  let setSelectedLocations = useDataChange({
    context: 'selected',
    path: 'locations',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!locations.length) return
    setSelectedLocations(locations)
  }, [locations]) // eslint-disable-line

  return <View viewPath={props.viewPath} />
}
